import { j as s } from "./jsx-runtime-3tyXYecC.mjs";
import { B as r, A as t } from "./avatar-Cf_y9mVA.mjs";
const o = (a) => /* @__PURE__ */ s.jsx(r, { ...a });
o.Avatar = t;
export {
  o as T
};
//# sourceMappingURL=tile-v2-7wNQfEB8.mjs.map
